import * as nodeEditor from "node-editor/legacy/legacy";
export { nodeEditor };
export default nodeEditor;
